import type { RouteRecordRaw } from 'vue-router';

export const customersRoutes: RouteRecordRaw[] = [
  {
    path: 'customers',
    name: 'customers',
    component: () => import('./pages/CustomersListPage.vue'),
    meta: { title: 'Clients', requiresAuth: true, role: 'customer', permission: 'view_customers' },
  },
  {
    path: 'customers/new',
    name: 'customers.create',
    component: () => import('./pages/CustomerFormPage.vue'),
    meta: { title: 'New client', requiresAuth: true, role: 'customer' },
  },
  {
    path: 'customers/:id',
    name: 'customers.show',
    component: () => import('./pages/CustomerFormPage.vue'),
    meta: { title: 'Client', requiresAuth: true, role: 'customer' },
  },
];
